// @ts-nocheck
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import InfoPageLayout, { InfoSection, InfoList } from "../components/InfoPageLayout";
import { requestAccountDeletion } from "../api/moderation";
import { getUser, setUser } from "../auth/auth";
import { useToast } from "../components/ToastProvider";
import "../styles/InfoPage.css";

export default function AccountDeletion() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [submitting, setSubmitting] = useState(false);
  const [scheduledFor, setScheduledFor] = useState(null);

  const handleDelete = async () => {
    const user = getUser();
    if (!user?.id) {
      showToast("You need to be signed in to request deletion.", "error");
      return;
    }

    setSubmitting(true);
    try {
      const result = await requestAccountDeletion(user.id);
      setScheduledFor(result?.scheduledFor || null);
      setUser({
        ...user,
        deletionRequested: true,
        deletionRequestedAt: new Date().toISOString(),
        deletionScheduledFor: result?.scheduledFor || null,
      });
      showToast(result?.message || "Account deletion requested", "success");
    } catch (error) {
      showToast(error?.message || "Failed to request deletion", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/settings");
  };

  return (
    <InfoPageLayout
      title="Request Account Deletion"
      subtitle="This will schedule your account for deletion in 30 days."
      updated="February 7, 2026"
    >
      <InfoSection title="What happens next">
        <InfoList>
          <li>Your account will be scheduled for deletion.</li>
          <li>
            You can cancel deletion at any time within <strong>30 days</strong> from Settings.
          </li>
          <li>Your profile, messages, and listings will no longer be accessible after deletion completes.</li>
          <li>All data is removed once deletion completes.</li>
        </InfoList>
      </InfoSection>

      <InfoSection title="Need help?">
        <p>Contact support@cardexhq.com if you need assistance or have questions about deletion.</p>
        <p>Cardex does not store payment, shipping, or transaction data.</p>
      </InfoSection>

      <InfoSection>
        <div className="info-actions">
          <button className="info-btn info-btn-secondary" onClick={handleCancel}>
            Keep Account
          </button>
          <button className="info-btn info-btn-danger" onClick={handleDelete} disabled={submitting || Boolean(scheduledFor)}>
            {submitting ? "Submitting..." : scheduledFor ? "Deletion Requested" : "Request Deletion"}
          </button>
        </div>
        {scheduledFor && (
          <p className="info-helper">
            Deletion is scheduled for {new Date(scheduledFor).toLocaleDateString()}. You can cancel it from Settings before then.
          </p>
        )}
      </InfoSection>
    </InfoPageLayout>
  );
}
